import { client, deserializer } from './client'
import { toSnake, toCamel } from 'change-object-case'
import { classifyError } from 'constants/rocketReachErrors'

/**
 * @param {*} formData - { page_offset, page_size, name | email }
 * @returns {object} - { data: object, meta?: object } | { error: Error }
 */
async function searchRocketReach(formData) {
  try {
    const response = await client().post('/v2/rocket_reach/search', toSnake(formData))

    return {
      data: toCamel(deserializer.deserialize(response), { arrayRecursive: true }),
      meta: toCamel(response.meta),
    }
  } catch (error) {
    // Classify the error but return it instead of throwing
    const classifiedError = classifyError(error)
    return {
      error: classifiedError,
    }
  }
}

/**
 * @param {string} id - The id of the entity to get the details for
 * @returns {object} - { data: object } | { error: Error }
 */
async function getContactDetails(id) {
  try {
    const response = await client().get(`/v2/rocket_reach/${id}/lookup`)

    return {
      data: toCamel(deserializer.deserialize(response), { arrayRecursive: true }),
    }
  } catch (error) {
    // Classify the error but return it instead of throwing
    const classifiedError = classifyError(error)
    return {
      error: classifiedError,
    }
  }
}

/**
 * @param {string} id - The id of the entity to check status for
 * @returns {object} - { data: object } | { error: Error }
 */
async function checkContactStatus(id) {
  try {
    const response = await client().get(`/v2/rocket_reach/${id}/check_status`)

    return {
      data: toCamel(deserializer.deserialize(response), { arrayRecursive: true }),
    }
  } catch (error) {
    // Classify the error but return it instead of throwing
    const classifiedError = classifyError(error)
    return {
      error: classifiedError,
    }
  }
}

export { searchRocketReach, getContactDetails, checkContactStatus }
